angular.module('zc')
  .component('zcIwConversionRate', {
    templateUrl: '/templates/projects.iw/iw_conversion_rate.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwConversionRateController
  });

zcIwConversionRateController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'columnChartV2Config', 'iwGraphOptions', 'lib'];
function zcIwConversionRateController($scope, $translate, InterestWidgetStats, ChartV2, columnChartV2Config, iwGraphOptions, lib) {
  const vm = this;

  const graphOption = iwGraphOptions[0];
  const tooltip = {
    valueSuffix: graphOption.unit,
    valueDecimals: graphOption.decimal
  };

  const chart = new ChartV2(columnChartV2Config, {
    xAxis: { categories: [$translate.instant('projectsIw.conversionRate.iwUse'), $translate.instant('projectsIw.conversionRate.noIwUse')] }
  });
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        chart.resetSeries();
        let data = (stats.length) ? [vm.total.iw_use.conversion_rate, vm.total.no_iw_use.conversion_rate] : [0, 0];
        chart.addSeries({
          colorByPoint: true,
          name: graphOption.label,
          data: data,
          tooltip: tooltip
        });
      });
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.iw/iw_conversion_rate.js